<div class="toast-stack">
  @for (t of toastService.toasts(); track t.id) {
    <div class="toast toast--{{t.type}}">
      <div class="toast__icon">
        @if (t.type === 'success') {
          <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 10l4 4 8-8"/>
          </svg>
        } @else if (t.type === 'error') {
          <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 5l10 10M15 5L5 15"/>
          </svg>
        } @else {
          <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="10" cy="10" r="8"/>
            <path d="M10 7v3.5M10 14h.01"/>
          </svg>
        }
      </div>
      <span class="toast__msg">{{ t.message | translate }}</span>
      <button type="button" class="toast__close" (click)="toastService.dismiss(t.id)" aria-label="Dismiss">
        <svg width="12" height="12" viewBox="0 0 20 20" fill="none" stroke="currentColor"
             stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 5l10 10M15 5L5 15"/>
        </svg>
      </button>
    </div>
  }
</div>
